import Action from '../action';

export const REQUEST_USER = '@user/REQUEST_USER';
export const REQUEST_USER_FAIL = '@user/REQUEST_USER_FAIL';
export const REQUEST_USER_SUCCESS = '@user/REQUEST_USER_SUCCESS';
export const REQUEST_CLAIMS_SUCCESS = '@user/REQUEST_CLAIMS_SUCCESS';

export const REQUEST_REFRESH_TOKEN = '@user/REQUEST_REFRESH_TOKEN';
export const REQUEST_REFRESH_TOKEN_FAIL = '@user/REQUEST_REFRESH_TOKEN_FAIL';
export const REQUEST_REFRESH_TOKEN_SUCCESS = '@user/REQUEST_REFRESH_TOKEN_SUCCESS';

export const RECEIVE_USER_CLAIMS = '@user/RECEIVE_USER_CLAIMS';

export const REQUEST_USER_ACCOUNTS = '@user/REQUEST_USER_ACCOUNTS';
export const REQUEST_USER_ACCOUNTS_FAIL = '@user/REQUEST_USER_ACCOUNTS_FAIL';
export const REQUEST_USER_ACCOUNTS_SUCCESS = '@user/REQUEST_USER_ACCOUNTS_SUCCESS';

export const ACCOUNT_REQUESTED = '@account/ACCOUT_REQUESTED';
export const ACCOUNT_RECEIVED = '@account/ACCOUT_RECEIVED';

export const REQUEST_DATAPOINTS_DESCRIPTORS = '@account/REQUEST_DATAPOINTS_DESCRIPTORS';
export const REQUEST_DATAPOINTS_DESCRIPTORS_FAIL = '@account/REQUEST_DATAPOINTS_DESCRIPTORS_FAIL';
export const REQUEST_DATAPOINTS_DESCRIPTORS_SUCCESS = '@account/REQUEST_DATAPOINTS_DESCRIPTORS_SUCCESS';

export const requestUser = () => Action(REQUEST_USER);
export const requestUserSuccess = payload => Action(REQUEST_USER_SUCCESS, payload);
export const requestClaimsSuccess = payload => Action(REQUEST_CLAIMS_SUCCESS, payload);
export const receiveUserClaims = payload => Action(RECEIVE_USER_CLAIMS, payload);
export const requestUserFailed = error => Action(REQUEST_USER_FAIL, error, true);
export const requestRefreshToken = () => Action(REQUEST_REFRESH_TOKEN);
export const refreshTokenSuccess = payload => Action(REQUEST_REFRESH_TOKEN_SUCCESS, payload);
export const refreshTokenFail = error => Action(REQUEST_REFRESH_TOKEN_FAIL, error, true);
export const retrieveAccount = () => Action(ACCOUNT_REQUESTED);
export const retrieveDatapointsDescriptors = () => Action(REQUEST_DATAPOINTS_DESCRIPTORS);
export const requestUserAccounts = () => Action(REQUEST_USER_ACCOUNTS);
export const requestUserAccountsSuccess = payload => Action(REQUEST_USER_ACCOUNTS_SUCCESS, payload);
export const requestUserAccountsFail = error => Action(REQUEST_USER_ACCOUNTS_FAIL, error, true);
export const requestDatapointsDescriptorsSuccess = payload => Action(REQUEST_DATAPOINTS_DESCRIPTORS_SUCCESS, payload);
export const requestDatapointsDescriptorsFail = error => Action(REQUEST_DATAPOINTS_DESCRIPTORS_FAIL, error, true);
